<template>
    <div class="wh-box">
        <div class="wh-content">
            <img src="../../assets/images/logo.png" alt="logo">
            <div class="wh-infor">
                <img src="../../assets/images/wh.png" alt="系统维护" class="wh-img">
                <h1>系统维护中</h1>
                <p>维护时间：</p>
                <h4>2021/06/06 17:00:00 ~ 2021/06/08 17:00:00</h4>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .wh-box {
        background: url('../../assets/images/whbg.jpg') no-repeat;
        width: 100%;
        height: 100%;
        background-size: cover;
        position: relative;
        img {
            width: 133px;
            height: 40px;
            display: block;
        }
        .wh-img {
            width: 385px;
            height: 314px;
            margin: 0 auto;
        }
    }
    .wh-content {
        @include gwidth;
        padding-top: 40px;
    }
    .wh-infor {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        height: 500px;
        width: 600px;
        text-align: center;
        h1 {
            font-size: 36px;
            font-weight: 600;
            color: #2c2e33;
            margin-top: 40px;
            margin-bottom: 50px;
        }
        p {
            color: #909399;
            font-size: 16px;
        }
        h4 {
            font-size: 18px;
            color: $common-color;
            font-weight: 400;
            margin-top: 0;
        }
    }
</style>